export enum Route {
    List = "documents",
    GetPredefinedDocuments = "documents/get-predefined-documents",
}

export const GetDocumentFileRoute = (assetId: number) => `${Route.List}/${assetId}/file`;